import OatsOatmealProduct from 'models/OatsOatmealProduct'

export const oatTypeOptions = [
  {
    value: '',
    label: 'Oat Type',
    isDisabled: true,
  },
  {
    value: 'Rolled',
    label: 'Rolled',
  },
  { value: 'Cut', label: 'Cut' },
  { value: 'Steel Cut', label: 'Steel Cut' },
  { value: 'Other', label: 'Other' },
]

export const oatCookingTypeOptions = [
  {
    value: '',
    label: 'Oat Cooking Type',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Quick', label: 'Quick' },
  { value: 'Instant', label: 'Instant' },
]

export const oatVarietyOptions = [
  {
    value: '',
    label: 'Oat Variety',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Old Fashioned', label: 'Old Fashioned' },
  { value: 'Other', label: 'Other' },
]

export const packagingInitialState = {
  category: OatsOatmealProduct.category,
  subCategory: OatsOatmealProduct.subCategory,
  GrainSize: '',
  OatType: {
    value: oatTypeOptions[0].value,
    label: oatTypeOptions[0].label,
  },
  CookingType: {
    value: oatCookingTypeOptions[0].value,
    label: oatCookingTypeOptions[0].label,
  },
  OatVariety: {
    value: oatVarietyOptions[0].value,
    label: oatVarietyOptions[0].label,
  },
}
